export const partnerRegionalMultiplierSagaActionTypes = {
  callPartnerRegionalMultiplierListSaga: "callPartnerRegionalMultiplierListSaga",
  callAddPartnerRegionalMultiplierSaga: "callAddPartnerRegionalMultiplierSaga",
  callUpdatePartnerRegionalMultiplierSaga: "callUpdatePartnerRegionalMultiplierSaga",
  callDeletePartnerRegionalMultiplierSaga: "callDeletePartnerRegionalMultiplierSaga",
};


export const getPartnerRegionalMultiplierListSagaAction: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: partnerRegionalMultiplierSagaActionTypes.callPartnerRegionalMultiplierListSaga,
    payload: {
      ID: ID,
    },
  };
};

export type AddPartnerRegionalMultiplierDetailsType = {
  ID: number,
  country: string,
  region: string,
  region_code: string,
  value: number,
};

export type AddEngagementDetailsType = {
  activity_name: string,
  category_id: any,
  accelerator_value: LevelsAcceleratorValue[],
  is_partner_editable: any,
  status: any,
  comments:string,
  description:string,
  ID?:number,
  category?:any
};

 type LevelsAcceleratorValue = {
  option_key: string,
  option_value:any
};

export const addPartnerRegionalMultiplierSagaAction: (data: AddPartnerRegionalMultiplierDetailsType) => {
  type: string;
  payload: AddPartnerRegionalMultiplierDetailsType;
} = (data: AddPartnerRegionalMultiplierDetailsType) => {
  return {
    type: partnerRegionalMultiplierSagaActionTypes.callAddPartnerRegionalMultiplierSaga,
    payload: data,
  };
};


export type updatePartnerRegionalMultiplierDetailsType = {
    ID: number,
  country: string,
  region: string,
  region_code: string,
  value: number,
};

export const updatePartnerRegionalMultiplierListSagaAction: (partnerRegionalMultiplier: updatePartnerRegionalMultiplierDetailsType) => {
  type: string;
  payload: {
    partnerRegionalMultiplier: updatePartnerRegionalMultiplierDetailsType;
  };
} = (partnerRegionalMultiplier: updatePartnerRegionalMultiplierDetailsType) => {
  return {
    type: partnerRegionalMultiplierSagaActionTypes.callUpdatePartnerRegionalMultiplierSaga,
    payload: {
      partnerRegionalMultiplier: partnerRegionalMultiplier,
    },
  };
};

export const deletePartnerRegionalMultiplierListSagaAction: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: partnerRegionalMultiplierSagaActionTypes.callDeletePartnerRegionalMultiplierSaga,
    payload: {
      ID: ID,
    },
  };
};